var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GoogleLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9996 10.9999H18.5621C18.5639 12.7519 17.9581 14.4503 16.8479 15.8056C15.7377 17.1609 14.1918 18.0892 12.4738 18.4324C10.7557 18.7755 8.97187 18.5121 7.42625 17.6872C5.88062 16.8623 4.66892 15.5269 3.99767 13.9087C3.32642 12.2904 3.23718 10.4894 3.74515 8.81267C4.25313 7.13595 5.32688 5.6873 6.78339 4.71365C8.23989 3.73999 9.98898 3.30159 11.7325 3.47318C13.4761 3.64477 15.1062 4.41572 16.3449 5.65463",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.af7503dfd65e6b787d7895d49a60549d.svg";
export { ForwardRef as ReactComponent };